import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProductDetails from "../../Pages/Client/ProductDetails";
import "./ProductModal.css";

// Opens a product on top of the page it was clicked from (Home, product list, ...).
// The page underneath stays mounted, so going back does not reload it or lose its
// scroll position. The URL is still /product/:id, so refresh and shared links work.
export default function ProductModal() {
  const { t } = useTranslation("common");
  const location = useLocation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const depth = location.state?.modalDepth || 1;

  // Lock the page behind the modal so only the modal scrolls.
  useEffect(() => {
    const { body } = document;
    const previous = body.style.overflow;
    body.style.overflow = "hidden";
    return () => {
      body.style.overflow = previous;
    };
  }, []);

  // Opening another product from inside the modal starts at the top.
  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
  }, [location.pathname]);

  // Go back past every product opened in this modal, straight to the page underneath.
  function close() {
    navigate(-depth);
  }

  return (
    <div className="product-modal-overlay" ref={scrollRef} role="dialog" aria-modal="true">
      <ProductDetails />
      <button type="button" className="product-modal-close" onClick={close} aria-label={t("close", "Close")}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
